export default "__VITE_ASSET__iM_B7VFA__"